import { ContractorsVendorView } from '@app/pages/vendor-rep/contractors-list/contractors-list.config';

export function filterContractorsList(
  data: ContractorsVendorView[],
  filters: any,
): ContractorsVendorView[] {
  return data.filter((contractor) => {
    const statusMatch = !filters.status || contractor.status === filters.status;
    const locationMatch =
      !filters.location || contractor.location === filters.location;
    const managerMatch =
      !filters.reportingManager ||
      contractor.reportingManager === filters.reportingManager;
    return statusMatch && locationMatch && managerMatch;
  });
}
